/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.security.site-page-editors'},
});

const SitePageEditorsItem = () => (
  <RouteLinkItem
    route="midas/settings/security/site-page-editors"
    title={messages.title}
  />
);

export default SitePageEditorsItem;
